import { IButton } from "../interfaces";
import { GaButton } from "./gaia/GaButton";

export const Button = (props: IButton) => {
    const { onclick, onKeyDown, text, title, className, disabled, dataTestId } = props;
    
    if (window.useGaiaDesign) {
        return <GaButton {...props} />;
    }

    return (
        <>
            <button
                data-testid={dataTestId}
                className={`btn ${className}`}
                onClick={onclick}
                onKeyDown={onKeyDown}
                title={title}
                disabled={disabled}
            >
                {text}
                {props.children}
        </button>
        </>
    )
}